import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import GetDataSourceTypesResult from "../classes/api/result/datasourcemodule/GetDataSourceTypesResult";
import GetDataSourcesResult from "../classes/api/result/datasourcemodule/GetDataSourcesResult";

import DataSourceTypeListDto from "../classes/dtos/datasourcemodule/DataSourceTypeListDto";
import DataSourceConnectorTypeListDto from "../classes/dtos/datasourcemodule/DataSourceConnectorTypeListDto";
import DataSourceAuthenticationDto from "../classes/dtos/datasourcemodule/DataSourceAuthenticationDto";
import DataSourceAuthenticationDetailDto from "../classes/dtos/datasourcemodule/DataSourceAuthenticationDetailDto";
import DataSourceListDto from "../classes/dtos/datasourcemodule/DataSourceListDto";
import DataSourceDetailDto from "../classes/dtos/datasourcemodule/DataSourceDetailDto";
import CreateOrUpdateDataSourceResult from "../classes/api/result/datasourcemodule/CreateOrUpdateDataSourceResult";
import DeleteDataSourceResult from "../classes/api/result/datasourcemodule/DeleteDataSourceResult";
import DataSourceTypeDetailDto from "../classes/dtos/datasourcemodule/DataSourceTypeDetailDto";
import UserDto from "../classes/dtos/accountmodule/UserDto";
import DataSourceUsageDto from "../classes/dtos/datasourcemodule/DataSourceUsageDto";
import PathListDto from "../classes/dtos/pathmodule/PathListDto";

const DataSourceApi = {

    GetDataSourceTypesByCustomerAsync: async function (readable: boolean | null, writable: boolean | null): Promise<ProcessingResult<GetDataSourceTypesResult>> {
        let authSession = await AuthToken.get();

        const queryParams = new URLSearchParams();

        if (readable != null) {
            queryParams.append("readable", readable.toString());
        }

        if (writable != null) {
            queryParams.append("writable", writable.toString());
        }

        const parameters = queryParams.size > 0 ? "?" + queryParams.toString() : "";

        const response = await fetch(Settings.api_url + "/DataSource/GetDataSourceTypesByCustomer" + parameters, {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            let result = data.dataSourceTypes.map((e: any) => new DataSourceTypeListDto(e.id, e.name, e.sourceType, e.connectorTypes.map((x: any) => new DataSourceConnectorTypeListDto(x.id, x.name)), e.authentications.map((x: any) => new DataSourceAuthenticationDto(x.label, x.key, x.details.map((y: any) => new DataSourceAuthenticationDetailDto(y.label, y.key, y.toEnter, y.toGenerate, y.toStore, y.isSecret, y.isRequired))))));
            result = result.toSorted((a: DataSourceTypeListDto, b: DataSourceTypeListDto) => (a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1 : (a.Name.toLowerCase() < b.Name.toLowerCase()) ? -1 : 0);
            return ProcessingResult.Ok(new GetDataSourceTypesResult(result));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetDataSourcesByCustomerAsync: async function (readable: boolean | null, writable: boolean | null): Promise<ProcessingResult<GetDataSourcesResult>> {
        let authSession = await AuthToken.get();

        const queryParams = new URLSearchParams();

        if (readable != null) {
            queryParams.append("readable", readable.toString());
        }

        if (writable != null) {
            queryParams.append("writable", writable.toString());
        }

        const parameters = queryParams.size > 0 ? "?" + queryParams.toString() : "";

        const response = await fetch(Settings.api_url + "/DataSource/GetDataSources" + parameters, {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new GetDataSourcesResult(data.dataSources.map((e: any) => new DataSourceListDto(e.id, e.name, new DataSourceTypeDetailDto(e.type.id, e.type.name), e.connectorType, new UserDto(e.createdBy.id, e.createdBy.email, e.createdBy.firstName, e.createdBy.lastName))), data.pathDataTables.map((e: any) => new PathListDto(e.id, e.name, e.typeId, e.typeLabel, e.createdBy, e.creationDate, e.updateDate, e.currentPeriodRuns, e.allPeriodsRuns))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateDataSourceAsync: async function (name: string, dataSourceType: number, customerAgentId: number | null, connectorType: number, parameters: object): Promise<ProcessingResult<CreateOrUpdateDataSourceResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/DataSource/CreateDataSource", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'dataSource':
                {
                    'id': 0,
                    'name': name,
                    'type': dataSourceType,
                    'customerAgentId': customerAgentId,
                    'connectorType': connectorType,
                    'parameters': parameters
                }
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new CreateOrUpdateDataSourceResult(data.id, data.ok, data.errorDetails));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    UpdateDataSourceAsync: async function (id: number, name: string, dataSourceType: number, customerAgentId: number | null, connectorType: number, parameters: object): Promise<ProcessingResult<CreateOrUpdateDataSourceResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/DataSource/UpdateDataSource", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'dataSource':
                {
                    'id': id,
                    'name': name,
                    'type': dataSourceType,
                    'customerAgentId': customerAgentId,
                    'connectorType': connectorType,
                    'parameters': parameters
                }
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new CreateOrUpdateDataSourceResult(data.id, data.ok, data.errorDetails));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeleteDataSourceAsync: async function (dataSourceId: number): Promise<ProcessingResult<DeleteDataSourceResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/DataSource/DeleteDataSource?dataSourceId=" + dataSourceId.toString(), {
            method: "Delete",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new DeleteDataSourceResult(data.deleted, data.usageDetails.map((e:any) => new DataSourceUsageDto(e.pathId,e.pathName,e.pathType))));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetDataSourceByIdAsync: async function (id: number): Promise<ProcessingResult<DataSourceDetailDto>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/DataSource/GetDataSourceById?dataSourceId=" + id, {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new DataSourceDetailDto(data.dataSource.id, data.dataSource.name, new DataSourceTypeDetailDto(data.dataSource.type.id, data.dataSource.type.name) , data.dataSource.connectorType, data.dataSource.createdById, data.dataSource.customerAgentId, data.dataSource.parameters));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default DataSourceApi;